import { styled } from '@clickcease/cc-client-components-lib'

export const HeaderContainer = styled('div', {
  width: '644px',
  display: 'flex',
  flexDirection: 'column',
  justifyItems: 'center',
  padding: '$8 $12',
  borderBottom: '1px solid $lightNeutral',
})

export const DescriptionContainer = styled('div', {
  marginBlockStart: '$4',
})

export const TagsContainer = styled('div', {
  width: '650px',
})

export const TagsSelectionRow = styled('div', {
  width: 'calc(100% - 20px)',
  display: 'flex',
  alignItems: 'center',
  padding: '$6 $5',

  '> :nth-child(1)': {
    flex: '1',
  },
  '> :nth-child(2)': {
    flex: '1',
  },
  '> :nth-child(3)': {
    flex: '0.1',
  },
})

export const TagListContainer = styled('div', {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
})

export const InputContainer = styled('div', {
  position: 'relative',
})

export const Prefix = styled('span', {
  fontSize: '$md',
  fontWeight: '$r',
})

export const RemoveButton = styled('button', {
  all: 'unset',
  cursor: 'pointer',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '30px',
  height: '30px',
  fontSize: '1.3rem',
  '&:hover': {
    color: '$primaryColor',
  },
  '&:disabled': {
    cursor: 'not-allowed',
    color: '$lightNeutral',
  },
})

export const TooltipContainer = styled('div', {
  display: 'flex',
  alignItems: 'center',
  '> :nth-child(2)': {
    marginInlineStart: '$4',
  },
})
